module.exports = __webpack_public_path__ + "img/脚型报告智能推荐鞋款.91ca061f.png";